<template>
  <div class="banner">
    <!-- 空格 -->
    <div class="kong"></div>
    <div class="container">
      <div class="row">
        <div class="image-box">
          <img src="../assets/yunyan-11.jpg" alt="">
        </div>
        <div class="content-box">
          <div class="sec-title text-left">
            <h2>产品介绍</h2>
          </div>
          <div class="text">
            跨境电商综合服务平台实现通关数据在电商企业和海关、税务、外管、银行之间实现安全、稳定、顺畅的交互传输，
            为跨境电商企业开展业务提供稳定高效的系统支持。
            平台通过数据交换模块实现电商企业与商务局、物流、支付、金融、仓储、海关监管场所等企业数据信息的对接和共享，提高效率，
            降低成本，构建跨境电商一站式综合服务体系，平台下设通关、税务、外汇、金融服务模块，一站式解决跨境电商全流程合规落地问题。
          </div>
        </div>
      </div>
      <div class="row2">
        <div class="p-title">
          产品优势
        </div>
        <div class="row2left">
          <div class="cpys">
            <img src="../assets/yunyan-3.png" alt="" style="vertical-align:middle">
            <span style="vertical-align:middle" class="sp-text">快速稳定</span>
            <span style="vertical-align:middle">系统传输稳定高效</span>
          </div>
          <div class="cpys">
            <img style="vertical-align:middle" src="../assets/yunyan-13.png" alt="">
            <span style="vertical-align:middle" class="sp-text">一站式对接</span>
            <span style="vertical-align:middle">物流、支付、金融、仓储、海关监管场所业务环节资源</span>
          </div>
          <div class="cpys">
            <img style="vertical-align:middle" src="../assets/yunyan-10.png" alt="">
            <span style="vertical-align:middle" class="sp-text">时效快</span>
            <span style="vertical-align:middle">低成本业务合规转化。</span>
          </div>
          <div class="cpys">
            <img style="vertical-align:middle" src="../assets/yunyan-11.png" alt="">
            <span style="vertical-align:middle" class="sp-text">跨境出口</span>
            <span style="vertical-align:middle">支持9610、9710、9810全模式通关</span>
          </div>
          <div class="cpys">
            <img style="vertical-align:middle" src="../assets/yunyan-5.png" alt="">
            <span style="vertical-align:middle" class="sp-text">贴心服务</span>
            <span style="vertical-align:middle">业务经理、客户经理、销售经理多对一的高品质服务</span>
          </div>
        </div>
        <div class="row2right">
          <img src="../assets/yunyan-2.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        idx: 0
      }
    },
  }
</script>
<style scoped>
  .image-box img {
    width: 100%;
  }

  .image-box {
    height: 460px;
    width: 570px;
    margin-top: 55px;
  }

  .text {
    height: 50px;
    line-height: 50px;
  }

  .kong {
    height: 150px;
  }

  .banner {
    background-image: none;
  }

  .container {
    width: 1200px;
    min-height: 700px;
    margin: 0 auto !important;
  }

  .sp-text {
    display: block;
    display: table-cell;
  }

  .row2right {
    float: left;
  }

  .row2right>img {
    width: 400px;
    height: 400px;
  }

  .row2left {
    width: 800px;
    float: left;
  }

  .cpys span:nth-child(even) {
    font-size: 18px;
    font-weight: bold;
    margin-left: 40px;
    width: 120px;
    display: inline-block;
  }

  .cpys span:nth-child(odd) {
    font-size: 18px;
  }

  .cpys {
    margin-top: 25px;
    height: 70px;
  }

  .cpys img {
    display: inline-block;
    max-width: 100%;
    height: auto;
  }

  .flex {
    margin-top: 50px;
  }

  .row2 {
    min-height: 600px;
    margin-top: 80px;
  }

  .row {
    height: 462px;
  }

  .row>div {
    float: left;
  }

  h2 {
    font-size: 20px;
    color: #0b77cf;
    margin-bottom: 22px;
    height: 52px;
    line-height: 52px;
  }

  .content-box {
    width: 553px;
    height: 400px;
    margin-left: 32px;
    margin-top: 52px;
  }

  .content-box p {
    color: #292828;
    margin: 35px 0;
  }

  .content-box p img {
    width: 12px;
    /* height: 18px; */
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Product.vue